<template>
  <section class="features-section py-4 py-lg-5 px-3 px-md-4">
    <div class="container-fluid">
      
      <!-- تیتر و هدر بخش -->
      <div class="text-center mb-4 mb-lg-5" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
        <div class="section-badge d-inline-flex align-items-center gap-2 mb-2">
          <i class="bi bi-stars"></i>
          <span>{{ currentLang.badge }}</span>
        </div>
        <h2 class="section-title">{{ currentLang.title }}</h2>
        <p class="section-desc text-muted mx-auto">{{ currentLang.subtitle }}</p>
      </div>

      <!-- شبکه ۵ کارت ویژگی -->
      <div class="row g-3 g-lg-4 justify-content-center" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
        <div
          v-for="(feature, index) in currentLang.items"
          :key="index"
          class="col-12 col-sm-6 col-md-4 col-xl"
        >
          <div class="feature-card h-100 p-4 text-center d-flex flex-column align-items-center" :class="feature.theme">
            
            <!-- کپسول آیکون با افکت رنگی -->
            <div class="feature-icon-bubble mb-3">
              <i :class="feature.icon"></i>
            </div>

            <!-- عنوان و توضیحات -->
            <h3 class="feature-title mb-2">{{ feature.title }}</h3>
            <p class="feature-text text-muted mb-0 mt-auto">{{ feature.desc }}</p>

            <!-- نشان شماره مرحله/ویژگی -->
            <span class="feature-step-num">{{ '0' + (index + 1) }}</span>
          </div>
        </div>
      </div>

      <!-- بنر ماموریت و نتیجه‌گیری زیر کارت‌ها -->
      <div class="mission-banner mt-4 mt-lg-5 p-3 p-md-4 rounded-4" :dir="lang === 'fa' ? 'rtl' : 'ltr'">
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-center text-md-start">
          <div class="d-flex align-items-center gap-3">
            <div class="mission-spark-icon">
              <i class="bi bi-lightbulb-fill"></i>
            </div>
            <div>
              <h4 class="mission-title mb-1">{{ currentLang.missionTitle }}</h4>
              <p class="mission-desc text-muted mb-0">{{ currentLang.missionDesc }}</p>
            </div>
          </div>
          <router-link to="/courses" class="btn btn-mission px-4 py-2 text-nowrap">
            <span>{{ currentLang.ctaBtn }}</span>
            <i class="bi" :class="lang === 'fa' ? 'bi-arrow-left' : 'bi-arrow-right'"></i>
          </router-link>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { lang } from "@/plugins/lang";

import enText from "@/locales/en/LearningFeatures";
import faText from "@/locales/fa/LearningFeatures";

const translations = {
  en: enText,
  fa: faText,
};

const currentLang = computed(() => translations[lang.value]);

</script>

<style scoped>
/* هدر بخش */
.section-badge {
  background: rgba(0, 205, 196, 0.12);
  color: #008f89;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 6px 14px;
  border-radius: 50px;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #18324b;
}

.section-desc {
  max-width: 650px;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #18324b;

}


/* کارت‌های ویژگی */
.feature-card {
  /* background: #ffffff; */
  /* border: 1px solid #eef2f6; */
  border-radius: 22px;
  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04); */
  position: relative;
  overflow: hidden;
  transition: all 0.35s ease;
  z-index: 1;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.08);
}

.feature-step-num {
  position: absolute;
  top: 12px;
  right: 14px;
  font-size: 0.75rem;
  font-weight: 800;
  color: #cbd5e1;
  letter-spacing: 0.5px;
}

:dir(rtl) .feature-step-num {
  right: auto;
  left: 14px;
}

/* آیکون بابل گرد */
.feature-icon-bubble {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  transition: transform 0.35s ease;
}

.feature-card:hover .feature-icon-bubble {
  transform: scale(1.1) rotate(5deg);
}

.feature-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #18324b;
}

.feature-text {
  font-size: 0.84rem;
  line-height: 1.6;
}
/* ==========================================================================
   پالت رنگی شاد و کودکانه برای کارت‌های آموزشی (Kid-Friendly Theme)
   ========================================================================== */

.feature-card .feature-title,
.feature-card .feature-text,
.feature-card .feature-step-num {
  transition: color 0.3s ease;
}

/* --------------------------------------------------------------------------
   ترکیب ۱: رز لطیف و هلویی نرم (Blush & Soft Peach)
   -------------------------------------------------------------------------- */
.theme-coral {
  background: linear-gradient(135deg, #ffe5ec 0%, #ffeedd 100%);
  border: 1px solid #ffd1dc;
  box-shadow: 0 8px 20px rgba(255, 182, 193, 0.25);
}
.theme-coral .feature-title {
  color: #7c2d37 !important;
}
.theme-coral .feature-text {
  color: #9e4752 !important;
}
.theme-coral .feature-step-num {
  color: rgba(124, 45, 55, 0.2);
}
.theme-coral .feature-icon-bubble {
  background: #ffffff;
  color: #e76f83;
  box-shadow: 0 6px 14px rgba(231, 111, 131, 0.2);
}
.theme-coral:hover {
  border-color: #ffb8c6;
  box-shadow: 0 12px 28px rgba(255, 182, 193, 0.4);
}

/* --------------------------------------------------------------------------
   ترکیب ۲: آبی ابری و فیروزه‌ای شیری (Sky Blue & Soft Mint)
   -------------------------------------------------------------------------- */
.theme-cyan {
  background: linear-gradient(135deg, #dcf8fa 0%, #e0f2fe 100%);
  border: 1px solid #c2eef2;
  box-shadow: 0 8px 20px rgba(186, 230, 253, 0.35);
}
.theme-cyan .feature-title {
  color: #154c59 !important;
}
.theme-cyan .feature-text {
  color: #276b7b !important;
}
.theme-cyan .feature-step-num {
  color: rgba(21, 76, 89, 0.2);
}
.theme-cyan .feature-icon-bubble {
  background: #ffffff;
  color: #0ea5b7;
  box-shadow: 0 6px 14px rgba(14, 165, 183, 0.2);
}
.theme-cyan:hover {
  border-color: #a5e6ee;
  box-shadow: 0 12px 28px rgba(14, 165, 183, 0.28);
}

/* --------------------------------------------------------------------------
   ترکیب ۳: کرم وانیلی و کره موزی ملایم (Butter Cream & Soft Sunshine)
   -------------------------------------------------------------------------- */
.theme-yellow {
  background: linear-gradient(135deg, #fff7cc 0%, #ffedd5 100%);
  border: 1px solid #feeaa7;
  box-shadow: 0 8px 20px rgba(254, 215, 170, 0.35);
}
.theme-yellow .feature-title {
  color: #634300 !important;
}
.theme-yellow .feature-text {
  color: #855b03 !important;
}
.theme-yellow .feature-step-num {
  color: rgba(99, 67, 0, 0.2);
}
.theme-yellow .feature-icon-bubble {
  background: #ffffff;
  color: #e59e00;
  box-shadow: 0 6px 14px rgba(229, 158, 0, 0.2);
}
.theme-yellow:hover {
  border-color: #fde047;
  box-shadow: 0 12px 28px rgba(253, 224, 71, 0.35);
}

/* --------------------------------------------------------------------------
   ترکیب ۴: نعنایی موهیتویی و لیمویی بهاری (Soft Pistachio & Mint)
   -------------------------------------------------------------------------- */
.theme-green {
  background: linear-gradient(135deg, #dcfce7 0%, #ecfccb 100%);
  border: 1px solid #c7f4d2;
  box-shadow: 0 8px 20px rgba(187, 247, 208, 0.35);
}
.theme-green .feature-title {
  color: #144f32 !important;
}
.theme-green .feature-text {
  color: #236e47 !important;
}
.theme-green .feature-step-num {
  color: rgba(20, 79, 50, 0.2);
}
.theme-green .feature-icon-bubble {
  background: #ffffff;
  color: #22c55e;
  box-shadow: 0 6px 14px rgba(34, 197, 94, 0.2);
}
.theme-green:hover {
  border-color: #86efac;
  box-shadow: 0 12px 28px rgba(34, 197, 94, 0.28);
}

/* --------------------------------------------------------------------------
   ترکیب ۵: یاسی اسطوخودوسی و کتان پنبه‌ای (Lavender & Soft Lilac)
   -------------------------------------------------------------------------- */
.theme-purple {
  background: linear-gradient(135deg, #f3e8ff 0%, #fce7f3 100%);
  border: 1px solid #e9d5ff;
  box-shadow: 0 8px 20px rgba(233, 213, 255, 0.35);
}
.theme-purple .feature-title {
  color: #4c2270 !important;
}
.theme-purple .feature-text {
  color: #6b359c !important;
}
.theme-purple .feature-step-num {
  color: rgba(76, 34, 112, 0.2);
}
.theme-purple .feature-icon-bubble {
  background: #ffffff;
  color: #9333ea;
  box-shadow: 0 6px 14px rgba(147, 51, 234, 0.2);
}
.theme-purple:hover {
  border-color: #d8b4fe;
  box-shadow: 0 12px 28px rgba(147, 51, 234, 0.28);
}



/* بنر ماموریت پایین */
.mission-banner {
  background: linear-gradient(135deg, #f0fdfa, #f8fafc);
  border: 1.5px dashed #00cdc4;
}

.mission-spark-icon {
  width: 48px;
  height: 48px;
  background: #00cdc4;
  color: #ffffff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  flex-shrink: 0;
}

.mission-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #0f172a;
}

.mission-desc {
  font-size: 0.85rem;
}

.btn-mission {
  background: #18325b;
  color: #ffffff;
  border-radius: 50px;
  font-size: 0.88rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s ease;
}

.btn-mission:hover {
  background: #00cdc4;
  color: #ffffff;
  transform: translateY(-2px);
}

/* ریسپانسیو */
@media (max-width: 575.98px) {
  .section-title {
    font-size: 1.35rem;
  }
  .feature-card {
    padding: 18px 14px;
  }
  .section-badge {
    margin-top: 150px;

}
}
</style>
